import React, { useState, useEffect } from "react";
import styles from "./Sidebar.module.css";
import PrintHistory from "../PrintHistory/PrintHistory";
import UsageLogs from "../UsageLogs/UsageLogs";
import EventLogs from "../EventLogs/EventLogs";
import { IconContext } from "react-icons";
import { FaClipboardList } from "@react-icons/all-files/fa/FaClipboardList";
import { FaHistory } from "@react-icons/all-files/fa/FaHistory";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaAngleDoubleLeft } from "@react-icons/all-files/fa/FaAngleDoubleLeft";
import { FaAngleDoubleRight } from "@react-icons/all-files/fa/FaAngleDoubleRight";

const Sidebar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 700);
  const [activeComponent, setActiveComponent] = useState<string>("UsageLogs");

  useEffect(() => {
    const handleResize = () => {
      if (window?.innerWidth <= 700) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "PrintHistory":
        return <PrintHistory />;
      case "UsageLogs":
        return <UsageLogs />;
      case "EventLogs":
        return <EventLogs />;
      default:
        return <UsageLogs />;
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}
      >
        <ul className={styles.menu}>
          <li
            className={styles.menuItem}
            onClick={() => setActiveComponent("UsageLogs")}
          >
            <IconContext.Provider value={{ size: "1.3em" }}>
              <FaClipboardList
                size={21}
                className={styles.icon}
                style={{ marginBottom: "1%" }}
              />
            </IconContext.Provider>
            {isOpen && <span>Usage </span>}
          </li>
          <li
            className={styles.menuItem}
            onClick={() => setActiveComponent("PrintHistory")}
          >
            <IconContext.Provider value={{ size: "1.3em" }}>
              <FaHistory
                size={21}
                className={styles.icon}
                style={{ marginBottom: "1%" }}
              />
            </IconContext.Provider>
            {isOpen && <span>Print History</span>}
          </li>

          <li
            className={styles.menuItem}
            onClick={() => setActiveComponent("EventLogs")}
          >
            <IconContext.Provider value={{ size: "1.3em" }}>
              <FaCalendarAlt
                size={21}
                className={styles.icon}
                style={{ marginBottom: "1%" }}
              />
            </IconContext.Provider>
            {isOpen && <span>Event Log</span>}
          </li>
        </ul>
        <div className={styles.toggleButton} onClick={toggleSidebar}>
          {isOpen ? (
            <FaAngleDoubleLeft size={23} />
          ) : (
            <FaAngleDoubleRight size={23} />
          )}
        </div>
      </div>
      <div className={styles.content}>{renderComponent()}</div>
    </div>
  );
};

export default Sidebar;
